import log, { success } from "cslog";
import {
    botAxios,
    botLocalAxios,
    useAIImageGenerator,
    useBGRemove,
    useGenerateTempatePresetFromInput,
    useAIStudioRawImage,
} from "../_actions/bot";
import { result, set } from "lodash";
import { useEffect, useRef, useState } from "react";
import { queryClient } from "../_helpers/query";
import { useMutation } from "react-query";
import { restoreAccessToken } from "../_helpers/auth";

export function useImageProcessing(onSuccess, onDone = () => { }) {
    // const [config, setConfig] = useState({});
    const config = useRef({});

    const mutationGenImage = useAIImageGenerator((result) => {
        log.d(result, "result in useAIImageGenerator");
        if (result?.success) {
            const photo = result?.data?.data;
            log.d(photo, "Now photo success");
            log.d(config, "postpp config");
            onSuccess({
                success: true,
                // ...config,
                ...config.current,
                value: photo.id,
            });
            onDone();
        }
    });

    const mutationBGRemove = useBGRemove(
        (new_photo) => {
            log.d(new_photo, "Photo with bg removed");
            if (new_photo?.data?.success) {
                const photo = new_photo?.data?.file;
                log.d(photo, "Now photo success");
                onSuccess({
                    success: true,
                    ...config,
                    value: photo.id,
                });
                onDone();
            }
        },
        () => { }
    );
    //new hook
    const mutationRawImage = useAIStudioRawImage((result) => {
        log.d(result, "RAW image result");
        if (result?.success) {
            const photo = result?.data;
            onSuccess({
                success: true,
                ...config.current,
                value: photo.id,
            });
            onDone();
        }
    });

    const processImage = (block_id, data) => {
        log.d([block_id, data], "postpp Processing Image");

        Object.values(data).forEach((value) => {
            if (value?.prompt) {
                // setConfig({
                //     block_id: block_id,
                //     field_name: value?.key,
                // });
                config.current = {
                    block_id: block_id,
                    field_name: value?.key,
                };
                //new conditional checks for both raw and person style image
                if (value?.image_style === "raw") {
                    mutationRawImage.mutate({
                        image_style: value?.image_style_type,
                        user_input: value?.prompt,
                        model_name: "gemini-2.5-flash-image",
                        negative_space: value?.negative_space,
                        object_position: value?.object_position,
                        aspect_ratio: value?.ar,
                    });
                } else {
                    mutationGenImage.mutate({
                        prompt: value?.prompt,
                        config: {
                            bg_rm: value?.bg_rm,
                            image_style: value?.image_style,
                            ar: value?.ar,
                            object_position: value?.object_position,
                        },
                    });
                }
            } else if (value?.bg_rm) {
                // setConfig({
                //     block_id: block_id,
                //     field_name: value?.key,
                // });
                config.current = {
                    block_id: block_id,
                    field_name: value?.key,
                };
                mutationBGRemove.mutate({
                    filename: value?.image?.filename_disk,
                });
            }
        });
    };

    return { processImage };
}

export function useGenerateConceptPresetDataWithAI(setCanvas) {
    const mutation = useMutation(
        (data) => {
            return botAxios
                .post(`/gen/generate_concept_preset_data`, data, {
                    headers: {
                        Authorization: `Bearer ${restoreAccessToken()}`,
                    },
                })
                .then((res) => {
                    return res?.data;
                });
        },
        {
            onSuccess: (result, variables, context) => {
                // onSuccess(result);
                log.d(result, "result in useGenerateConceptPresetDataWithAI");
                if (result?.success) {
                    setCanvas({
                        success: true,
                        data: result?.data?.canvas || {},
                    });
                }
            },
        }
    );

    const updateInputs = (data) => {
        log.d(data, "Updating Inputs");
        mutation.mutate(data);
        // setCanvas({
        //     success: true,
        //     data: {
        //         linkedin_post: {
        //             content:
        //                 "🚀 Ever had a project that felt a bit like magic? \n\nRecently, we had the incredible opportunity to collaborate with an SME that was looking to streamline their operations. They needed a new internal workflow management tool — and fast!\n\nThanks to our partnership, we rolled it out in record time! The results?  \n• Reduced costs  \n• Increased operational efficiency  \n\nThis experience was a deep reminder of the power of teamwork and innovation. I believe that when we align our goals with our clients’ needs, we can create something truly special.  \n\nFor any SMEs out there looking to enhance their workflow, remember that the right tools can make all the difference.  \n\nLet’s keep pushing the boundaries of what’s possible together!\n\n#Collaboration #SMEs #Innovation #Efficiency #Teamwork",
        //         },
        //     },
        // });
    };

    return { updateInputs, isLoading: mutation.isLoading };
}

export function useGeneratePresetDataWithAI(setPrefill) {
    const { processImage } = useImageProcessing(
        (result) => {
            log.d(result, "Image processing result");
            if (result?.success) {
                setPrefill((old_prefill) => {
                    return {
                        ...old_prefill,
                        [result?.block_id]: {
                            ...old_prefill[result?.block_id],
                            [result?.field_name]: result?.value,
                        },
                    };
                });

                setTimeout(() => {
                    queryClient.invalidateQueries(["items", "qdb_token_plan"]);
                }, 2000);
                // if (onProcessComplete) {
                //     queryClient.invalidateQueries(["items", "qdb_token_plan"]);
                // }
            }
        }
        // {
        //     onSuccess: (data, variables, context) => {
        //         onSuccess();
        //         queryClient.invalidateQueries(["items", "qdb_token_plan"]);
        //         console.log("token reduction done");
        //     },
        // }
    );

    const mutation = useGenerateTempatePresetFromInput(
        (result) => {
            log.d(result, "Generated Preset Data");
            if (result?.success) {
                for (const [block_id, data] of Object.entries(result?.data)) {
                    if (data?.success) {
                        // const out = data?.data;
                        const out = data;
                        const post_processing = out?.post_processing;
                        const pp_keys = Object.keys(post_processing);
                        const pp_loading = {};
                        pp_keys.forEach((key) => {
                            // pp_loading[key] = { value: "loading" }
                            pp_loading[key] = "loading";
                        });

                        setPrefill((old_prefill) => {
                            return {
                                ...old_prefill,
                                // [block_id]: out?.data
                                [block_id]: {
                                    ...out?.data,
                                    ...pp_loading,
                                },
                                history_id: result?.data?.history_id,
                            };
                        });

                        if (pp_keys.length > 0) {
                            processImage(block_id, post_processing);
                        } else {
                            setTimeout(() => {
                                queryClient.invalidateQueries([
                                    "items",
                                    "qdb_token_plan",
                                ]);
                            }, 2000);
                        }
                    }
                }
            }
        },
        () => { }
    );

    const updateInputs = (data) => {
        log.d(data, "Updating Inputs");
        mutation.mutate(data);

        // processImage(data?.block_id, {
        //     person_photo: {
        //         key: "person_photo",
        //         image: {
        //             id: "aa9e55e6-ae78-49e2-ab60-d7f3cb85df94",
        //             filename: "aa9e55e6-ae78-49e2-ab60-d7f3cb85df94.png"
        //         },
        //         bg_rm: true
        //     }
        // })
    };

    const updatePrompt = (prompt) => { };

    return { updateInputs, updatePrompt, isLoading: mutation.isLoading };
}

export function usePostProcessing(prefill, generated_images = {}) {
    const [updated_prefill, setUpdatedPrefill] = useState(prefill);

    const { processImage } = useImageProcessing((result) => {
        log.d(result, "postpp Image processing result");
        if (result?.success) {
            setUpdatedPrefill((old_prefill) => {
                return {
                    [result?.block_id]: {
                        [result?.field_name]: result?.value,
                        // data: {
                        //     ...old_prefill[result?.block_id],
                        //     [result?.field_name]: result?.value,
                        // },
                    },
                };
            });

            setTimeout(() => {
                queryClient.invalidateQueries(["items", "qdb_token_plan"]);
            }, 2000);
            // if (onProcessComplete) {
            //     queryClient.invalidateQueries(["items", "qdb_token_plan"]);
            // }
        }
    });

    useEffect(() => {
        // alert("inside post processign")
        // setUpdatedPrefill(prefill);

        if (Object.keys(generated_images).length > 0) {
            setUpdatedPrefill(generated_images);
            return;
        }

        for (const [block_id, data] of Object.entries(prefill)) {
            if (data?.success) {
                // const out = data?.data;
                const out = data;
                const post_processing = out?.post_processing;
                const pp_keys = Object.keys(post_processing);
                const pp_loading = {};
                pp_keys.forEach((key) => {
                    // pp_loading[key] = { value: "loading" }
                    pp_loading[key] = "loading";
                });

                setUpdatedPrefill((old_prefill) => {
                    return {
                        ...old_prefill,
                        // [block_id]: out?.data
                        [block_id]: {
                            // data: {
                            //     ...out?.data,
                            //     ...pp_loading,
                            // },
                            ...pp_loading
                        },
                    };
                });

                if (pp_keys.length > 0) {
                    processImage(block_id, post_processing);
                } else {
                    // setTimeout(() => {
                    //     queryClient.invalidateQueries([
                    //         "items",
                    //         "qdb_token_plan",
                    //     ]);
                    // }, 2000);
                }
            }
        }
    }, [prefill]);

    return { updated_prefill };
}
